export default "__VITE_ASSET__VQ8Td3EO__"